import { Box, CircularProgress, Typography } from '@mui/material';
import { format, isToday } from 'date-fns';

import clock from '../../assets/common/clock.svg';

const BlockSubHeader = ({ text, time }: { text: string; time: Date | number | undefined }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                margin: '5px 0 25px',
            }}
        >
            <img src={clock} alt="clock"></img>
            <Typography
                component="span"
                sx={{
                    color: '#9298A1',
                    fontFamily: 'AvenirNext400',
                    fontSize: '16px',
                    margin: '0 5px',
                }}
            >
                {text}
            </Typography>
            {time ? (
                <Typography
                    component="span"
                    sx={{
                        color: '#0F0E0E',
                        fontFamily: 'AvenirNext500',
                        fontSize: '16px',
                    }}
                >
                    {isToday(time) ? 'Today at' : 'Yesterday at'} {format(time, 'HH:mm')}
                </Typography>
            ) : (
                <CircularProgress
                    sx={{
                        color: '#0F0E0E',
                        margin: '0 20px',
                    }}
                    size={16}
                ></CircularProgress>
            )}
        </Box>
    );
};
export default BlockSubHeader;
